import { FaMap } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { PiFarmFill } from "react-icons/pi";
import { FaEnvelope } from "react-icons/fa";
import "./BottomNav.css";


export const BottomNav = () => (
  <div className="bottom-nav">
    <ul className="bottom-nav-links">
      <li>
        <Link to="/betrieb">
          <PiFarmFill size={24} />
          <span className="nav-text">Betrieb</span>
        </Link>
      </li>
      <li>
        <Link to="/map">
          <FaMap size={24} />
          <span className="nav-text">Karte</span>
        </Link>
      </li>
      <li>
        <Link to="/profile">
          <CgProfile size={24} />
          <span className="nav-text">Profil</span>
        </Link>
      </li>
      <li>
        <Link className="footer-link !text-sm" to='/contact'> <FaEnvelope size={24} />
          <span className="nav-text">Kontakt</span>
          </Link>

      </li>
    </ul>
  </div>
);